import { call, put } from 'redux-saga/effects';
import * as api from '../../api';
import { hideModal, setCurrentId, showToast } from '../actions';
import {
  createSupplier,
  deleteSupplier,
  getSuppliers,
  updateSupplier,
} from '../actions/suppliers';

export function* getSuppliersSaga(action) {
  try {
    const response = yield call(api.getSuppliers, action.payload);
    yield put(getSuppliers.getSuppliersSuccess(response?.data.suppliers));
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(getSuppliers.getSuppliersFailure(error.response?.data));
  }
}

export function* createSupplierSaga(action) {
  try {
    const response = yield call(api.createSupplier, action.payload);
    yield put(createSupplier.createSupplierSuccess(response?.data.supplier));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(createSupplier.createSupplierFailure(error.response?.data));
  }
}

export function* updateSupplierSaga(action) {
  try {
    const response = yield call(api.updateSupplier, action.payload);
    yield put(updateSupplier.updateSupplierSuccess(response?.data.supplier));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(updateSupplier.updateSupplierFailure(error.response?.data));
  }
}

export function* deleteSupplierSaga(action) {
  try {
    const response = yield call(api.deleteSupplier, action.payload);
    yield put(deleteSupplier.deleteSupplierSuccess(response?.data.supplier));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(deleteSupplier.deleteSupplierFailure(error.response?.data));
  }
}
